import {Frontend} from "./frontend";

(function () {
    XonBoard.LiquefiedPetroleumGasSensorReads = {
        list: {

            selectors: {
                sensor_reads_table: $('#sensor-reads-table'),
                count_label: $('#count-label'),
            },

            init: function (cylinders_count) {

                let self = this;

                let columns = [
                    {data: 'received_date', name: 'sensor_reads.received_date', createdCell: self.renderCell,},
                ];

                for (let i = 1; i <= cylinders_count; i++) {
                    columns.push({data: 'rochester_gauge_' + i, name: 'sensor_reads.values->rochester_gauge_' + i, createdCell: self.renderCell,});
                    columns.push({data: 'temperature_' + i, name: 'sensor_reads.values->temperature_' + i, createdCell: self.renderCell,});
                }

                columns.push({data: 'actions', name: 'actions', searchable: false, sortable: false, createdCell: self.renderCell,});

                let table = this.selectors.sensor_reads_table.DataTable({
                    bInfo: false,
                    bLengthChange: false,
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: this.selectors.sensor_reads_table.data('ajax_url'),
                        type: 'post',
                        dataSrc(json) {
                            self.updateCount(json.recordsTotal);
                            return json.data;
                        },
                        data(d) {
                            const from_datetime = $('#from_datetime').val();
                            if (from_datetime) {
                                d.from_datetime = from_datetime;
                            }

                            const to_datetime = $('#to_datetime').val();
                            if (to_datetime) {
                                d.to_datetime = to_datetime;
                            }
                        },
                    },
                    columns: columns,
                    order: [[0, "desc"]],
                    searchDelay: 500,
                    dom: 'lBfrtip',
                    "createdRow": function (row, data, dataIndex) {
                        Frontend.Utils.dtAnchorToForm(row);
                    }
                });

                Frontend.DataTable.init(table);
                Frontend.DataTableSearch.init(table);
                XonBoard.Utils.Select2.init();
            },
            updateCount(total) {
                this.selectors.count_label.text(total);
            },
            renderCell(td, cellData) {
                if(cellData && cellData.value != null) {
                    $(td).addClass(cellData.class);
                    $(td).html(cellData.value);
                    return;
                }

                $(td).html(cellData);
            }
        },
    }
})();
